
export function grep (obj: Record<string, any>, regexp: string | RegExp, depth?: number, ownOnly?: boolean, parseValues?: boolean) {
  if (arguments.length < 2) { throw new Error('Grep | Need both an object and a search string/regexp!') }

  const rx: RegExp = typeof regexp === 'string' ? regexp = new RegExp(regexp, 'i') : regexp
  const dp = depth || 0

  const hits: Record<string, any> = {}
  const next: Array<any> = []
  let found = false
  let keys: Array<string>
  let name: string | undefined
  let what: Record<string, any> | undefined
  const getFieldValueasString = field => typeof field === 'object' && !Array.isArray(field) ? '' : (field || '').toString()

  try {
    keys = Object.getOwnPropertyNames(obj) // both enumerables and not
    if (!ownOnly) {
      for (name in obj) {
        if (keys.indexOf(name) === -1) { keys.push(name) }
      }
    }
  } catch (e) {
    return undefined // can typically only grab these from objects / functions
  }

  while ((name = keys.shift()) !== undefined) {
    if (rx.test(name) || (parseValues && rx.test(getFieldValueasString(obj[name])))) {
      hits[name] = obj[name]
      found = true
    } else if (dp && typeof obj[name] === 'object') { next.push(name) }
  }

  while ((name = next.shift()) !== undefined) {
    if ((what = grep(obj[name], rx, dp - 1, ownOnly)) !== undefined) {
      hits[name] = what
      found = true
    }
  }

  return found ? hits : undefined
}

grep.own = function (obj: Record<string, any>, rx: string | RegExp, depth = 1) {
  return grep(obj, rx, depth, true)
}

grep.contents = function (obj: Record<string, any>, rx: string | RegExp, depth = 1) {
  return grep(obj, rx, depth, true, true)
}
